import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { Section, SectionHeading } from '../Section';
import { CtaButton } from '../CtaButton';
import { faqs } from '../../data/faqs';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section tone="light" id="faq" data-id="element-158" data-mp="1223jfbsul82d">
      <SectionHeading invert eyebrow="❓ Before you decide" title="Frequently asked questions" data-id="element-159" data-mp="12355ebbejeyv" />

      <div className="mx-auto mt-9 max-w-3xl space-y-3" data-id="element-160" data-mp="1pspqazr48mas">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return <div key={faq.question} className="overflow-hidden rounded-xl border border-navy-950/10 bg-white" data-id="element-161" data-mp="1g2xslwnpzd23" data-mpi={index}>
              <h3 data-id="element-162" data-mp="1kzoampj34iq5">
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left text-[15px] font-bold text-navy-950 transition-colors duration-150 ease-out hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-500 sm:text-base" data-id="element-163" data-mp="1kz4rx6lm1qb2">
                  <span data-id="element-164" data-mp="2yhl9ym2e7n40">{faq.question}</span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-165" data-mp="2tplhfeonjwhg" />
                </button>
              </h3>
              {isOpen ? <p className="border-t border-navy-950/10 px-4 py-4 text-[15px] leading-relaxed text-slate-600" data-id="element-166" data-mp="3hdl3w2exl0q8">
                  {faq.answer}
                </p> : null}
            </div>;
      })}
      </div>

      <div className="mt-9 flex justify-center" data-id="element-167" data-mp="1n2pxn6r7xxqm">
        <CtaButton label="Get the Playbook now" subLabel="$27 one-time · 7-day guarantee" data-id="element-168" data-mp="1i2tt96em04aj" />
      </div>
    </Section>;
}